import React from 'react';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';

export const FollowUpRecapActionsSkeleton: React.FC = () => (
    <div data-testid="followup-recap-actions-skeleton" aria-hidden="true" className="flex flex-col items-start gap-s">
        {['w-40', 'w-32'].map(width => (
            <SkeletonBar key={width} className={`h-4 ${width}`} />
        ))}
    </div>
);
